import { InputTextArea, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  convertToValidPrice,
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";
import { SHOW_UPDATE } from "../../../PurchaseOrder/ui/ModalSimpan/ModalSimpan";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
  urlAcceptPembelian,
  urlCreatePembelian,
  urlCreatePembelianByPO,
  urlUpdatePembelian,
} from "../../helpers";
import moment from "moment";
import { Alert } from "@material-ui/lab";

const SHOW_BUKA_TRANSAKSI = {
  label: "BUKA TRANSAKSI",
  color: "green",
  state: true,
  disabled: false,
};

const SHOW_TUTUP_TRANSAKSI = {
  label: "KUNCI TRANSAKSI",
  color: "lightgreen",
  state: true,
  disabled: false,
};

const SHOW_PROCESS = {
  label: "TUTUP PEMBELIAN",
  color: "danger",
  state: true,
  disabled: false,
};
const ModalSimpan = ({
  setShowModal,
  setNewDataPembelianList,
  listPembelian,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI);
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS);
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE);
  const [disabledTutup, setDisabledTutup] = useState(SHOW_TUTUP_TRANSAKSI); // eslint-disable-line
  const [showModalForce, setShowModalForce] = useState(false); // eslint-disable-line

  const { formData, setFormData, totalJumlah } = useContext(FormContext);
  const [alasan, setAlasan] = useState("");

  // const handleChange = (text) => (e) => {
  //   setFormData({
  //     ...formData,
  //     [text]: e.target.value,
  //   });
  // };

  const handleClickBukaTransaksi = async (e) => {
    e.preventDefault();
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT);
    try {
      if (
        isNull(formData.gudang_id) ||
        isNull(formData.supplier_id) ||
        isNull(formData.produsen_id) ||
        isNull(formData.unit_id) ||
        isNull(formData.kasbank_id)
      ) {
        defaultToastError("Harap lengkapi form pembelian!");
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      } else {
        const api = await instance4.post(
          formData.is_po ? urlCreatePembelianByPO : urlCreatePembelian,
          {
            idgl: formData.idgl,
            date: moment(formData.faktur_tgl).format(),
            is_po: formData.is_po,
            po_id: formData.po_id === "" ? null : formData.po_id,
            gudang_id: formData.gudang_id,
            user: formData.user,
            supplier_id: formData.supplier_id,
            produsen_id: formData.produsen_id,
            faktur_no: formData.faktur_no,
            faktur_tgl: moment(formData.faktur_tgl).format(),
            jatuhtempo_tgl: moment(formData.jatuhtempo_tgl).format(),
            kedatangan_tgl: moment(formData.kedatangan_tgl).format(),
            tagih_tgl: moment(formData.tagih_tgl).format(),
            kasbank_id: formData.kasbank_id,
            kas_bank: formData.kasbank,
            coa_code: formData.coa_code,
            unit_id: formData.unit_id,
            status_pembelian: 0,
            biayalain: 0,
            ongkos: 0,
            potongan: 0,
            tax: formData.tax2,
            sisa: 0,
            is_changesellprice: false,
            bayar: 0,
          }
        );
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);

          setFormData({
            ...formData,
            id: res.id_pembelian,
            status: STATUS_OPEN_DRAFT_PEMBELIAN,
            // is_po: formData.is_po,
          });
          setNewDataPembelianList(res.id_pembelian);
        } else {
          defaultToastError(res?.message);
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
        }
      }
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickTutup = async (e) => {
    e.preventDefault();
    setDisabledTutup(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.gudang_id)) {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledTutup(SHOW_TUTUP_TRANSAKSI);
      } else {
        const api = await instance4.post(urlAcceptPembelian, {
          id: formData.id,
          gudang_id: formData.gudang_id,
          unit_id: formData.unit_id,
          status_pembelian: STATUS_PROSES_PEMBELIAN,
          is_changesellprice: formData.is_changesellprice,
          force: true,
          remark: alasan,
          total_pembayaran: totalJumlah.totalJumlah,
          sub_total_lain: totalJumlah.totalLain,
          sub_total_disbarang: totalJumlah.subTotalDisBarang,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setFormData({
            ...formData,
            status: STATUS_PROSES_PEMBELIAN,
          });
          setNewDataPembelianList();
        } else {
          if (res.status === 205) {
            defaultToastSuccess("Berhasil");
            setShowModal(false);
            setFormData({
              ...formData,
              status: STATUS_PROSES_PEMBELIAN,
            });
            // setShowModalForce(true);
            setNewDataPembelianList();
          } else {
            defaultToastError(res?.message);
            setDisabledUpdate(SHOW_PROCESS);
          }
        }
      }
    } catch (error) {
      setDisabledTutup(SHOW_TUTUP_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickBukaKembali = async (e) => {
    e.preventDefault();
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.gudang_id === "") {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      } else {
        const api = await instance4.post(urlAcceptPembelian, {
          id: formData.id,
          gudang_id: formData.gudang_id,
          unit_id: formData.unit_id,
          status_pembelian: STATUS_OPEN_DRAFT_PEMBELIAN,
          is_changesellprice: formData.is_changesellprice,
          force: true,
          remark: alasan,
          total_pembayaran: totalJumlah.totalJumlah,
          sub_total_lain: totalJumlah.totalLain,
          sub_total_disbarang: totalJumlah.subTotalDisBarang,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setFormData({
            ...formData,
            status: STATUS_OPEN_DRAFT_PEMBELIAN,
          });
          setNewDataPembelianList();
        } else {
          if (res.status === 205) {
            defaultToastSuccess("Berhasil");
            setShowModal(false);
            setFormData({
              ...formData,
              status: STATUS_OPEN_DRAFT_PEMBELIAN,
            });
            // setShowModalForce(true);
            setNewDataPembelianList();
          } else {
            defaultToastError(res?.message);
            setDisabledUpdate(SHOW_PROCESS);
          }
        }
      }
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickProcess = async (e) => {
    e.preventDefault();
    setDisabledProcess(DISABLED_BUTTON_SUBMIT);
    try {
      if (formData.gudang_id === "") {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledProcess(SHOW_PROCESS);
      } else {
        const api = await instance4.post(urlAcceptPembelian, {
          id: formData.id,
          gudang_id: formData.gudang_id,
          unit_id: formData.unit_id,
          status_pembelian: STATUS_SELESAI_PEMBELIAN,
          is_changesellprice: formData.is_changesellprice,
          force: true,
          remark: alasan,
          total_pembayaran: totalJumlah.totalJumlah,
          sub_total_lain: totalJumlah.totalLain,
          sub_total_disbarang: totalJumlah.subTotalDisBarang,
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setFormData({
            ...formData,
            status: STATUS_SELESAI_PEMBELIAN,
          });
          setNewDataPembelianList();
        } else {
          if (res.status === 205) {
            defaultToastSuccess("Berhasil");
            setShowModal(false);
            setFormData({
              ...formData,
              status: STATUS_SELESAI_PEMBELIAN,
            });
            // setShowModalForce(true);
            setNewDataPembelianList();
          } else {
            defaultToastError(res?.message);
            setDisabledUpdate(SHOW_PROCESS);
          }
        }
      }
    } catch (error) {
      setDisabledProcess(SHOW_PROCESS);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleClickUpdate = async (e) => {
    e.preventDefault();
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(formData.gudang_id)) {
        defaultToastError("Gudang tidak boleh kosong!");
        setDisabledUpdate(SHOW_UPDATE);
      } else {
        const api = await instance4.post(urlUpdatePembelian, {
          id: formData.id,
          idgl: formData.idgl,
          date: moment(formData.faktur_tgl).format(),
          gudang_id: formData.gudang_id,
          user: formData.user,
          supplier_id: formData.supplier_id,
          produsen_id: formData.produsen_id,
          unit_id: formData.unit_id,
          kasbank_id: formData.kasbank_id,
          kas_bank: formData.kasbank,
          coa_code: formData.coa_code,
          faktur_no: formData.faktur_no,
          faktur_tgl: moment(formData.faktur_tgl).format(),
          jatuhtempo_tgl: moment(formData.jatuhtempo_tgl).format(),
          kedatangan_tgl: moment(formData.kedatangan_tgl).format(),
          tagih_tgl: moment(formData.tagih_tgl).format(),
          potongan: convertToValidPrice(formData.potongan2),
          ongkos: convertToValidPrice(formData.ongkos2),
          biayalain: convertToValidPrice(formData.biayalain2),
          tax: convertToValidPrice(formData.tax2),
        });
        const res = await api?.data;
        if (res.status === 200) {
          setShowModal(false);
          defaultToastSuccess(res?.message);
          setNewDataPembelianList();
        } else {
          defaultToastError(res?.message);
          setDisabledUpdate(SHOW_UPDATE);
        }
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE);
      defaultToastError(error?.response?.data?.message);
    }
  };

  // const getTotalJumlahPembelian = async () => {
  //   let sub_disc = 0;
  //   let sub_total_tanpa_disc = 0;

  //   await listPembelian.map((e) => {
  //     const subJumlah = e?.harga_satuan * e?.qty;
  //     const nilaiDisc = (parseFloat(e.disc) / 100) * subJumlah;
  //     sub_disc += nilaiDisc;
  //     sub_total_tanpa_disc += subJumlah;

  //     return true;
  //   });

  //   let jumlah = sub_total_tanpa_disc - sub_disc;

  //   let sub_total_dikurangi_potongan =
  //     jumlah - convertToValidPrice(formData.potongan2);

  //   let tax =
  //     (convertToValidPrice(formData.tax2) / 100) * sub_total_dikurangi_potongan;
  //   let sub_total_plus_tax = sub_total_dikurangi_potongan + tax;
  //   let ongkos = convertToValidPrice(formData.ongkos2);
  //   let biayalain = convertToValidPrice(formData.biayalain2);
  //   let total_jumlah =
  //     sub_total_plus_tax + parseFloat(ongkos) + parseFloat(biayalain);
  //   return convertToValidPrice(total_jumlah);
  // };

  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction='row'
        alignItems='center'
        style={{
          marginBottom: "1rem",
        }}>
        <RenderAction
          formData={formData}
          disabledBukaTransaksi={disabledBukaTransaksi}
          handleClickBukaTransaksi={handleClickBukaTransaksi}
          disabledUpdate={disabledUpdate}
          handleClickUpdate={handleClickUpdate}
          alasan={alasan}
          setAlasan={setAlasan}
          disabledProcess={disabledProcess}
          handleClickProcess={handleClickProcess}
          disabledTutup={disabledTutup}
          handleClickTutup={handleClickTutup}
          handleClickBukaKembali={handleClickBukaKembali}
        />
      </Grid>
    </Modal>
  );
};

const RenderAction = ({
  formData,
  disabledBukaTransaksi,
  handleClickBukaTransaksi,
  disabledUpdate,
  handleClickUpdate,
  alasan,
  setAlasan,
  disabledProcess,
  handleClickProcess,
  disabledTutup,
  handleClickTutup,
  handleClickBukaKembali,
}) => {
  if (isNull(formData.id)) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaTransaksi.color}
          name={disabledBukaTransaksi.label}
          disabled = {disabledBukaTransaksi.disabled}
          onClick={(e) =>
            disabledBukaTransaksi.disabled ? null : handleClickBukaTransaksi(e)
          }
          size='lg'
        />
      </>
    );
  } else {
    if (formData.status === STATUS_OPEN_DRAFT_PEMBELIAN) {
      return (
        <>
          <Alert severity='info' variant='outlined' style={{ width: "100%" }}>
            Harap lakukan update ketika melakukan perubahan data
          </Alert>
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledUpdate.color}
            onClick={(e) => disabledUpdate.disabled ? null : handleClickUpdate(e)}
            name={disabledUpdate.label}
            disabled = {disabledUpdate.disabled}
            size='lg'
          />
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledTutup.color}
            onClick={(e) => disabledTutup.disabled ? null : handleClickTutup(e)}
            name={disabledTutup.label}
            size="lg"
            disabled = {disabledTutup.disabled}
          />
        </>
      );
    } else if (formData.status === STATUS_PROSES_PEMBELIAN) {
      return (
        <>
          {" "}
          <InputTextArea
            name='remarkACC'
            label='CATATAN'
            id='remarkACC'
            placeholder='Catatan Tutup Pembelian'
            rows={3}
            value={alasan}
            onChange={(e) => {
              setAlasan(e.target.value);
            }}
          />
          <MasterButton
            className={"mt-05 w-full text-center"}
            type={"button"}
            color={disabledProcess.color}
            onClick={(e) =>
              disabledProcess.disabled ? null : handleClickProcess(e)
            }
            disabled = {disabledProcess.disabled}
            name={disabledProcess.label}
            size='lg'
          />
           <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledBukaTransaksi.color}
            onClick={(e) => disabledBukaTransaksi.disabled ? null : handleClickBukaKembali(e)}
            name={disabledBukaTransaksi.label}
            disabled = {disabledBukaTransaksi.disabled}
            size="lg"
          />
        </>
      );
    } else if (formData.status === STATUS_SELESAI_PEMBELIAN) {
      return <>Pembelian ini sudah selesai</>;
    } else {
      return <>Ada yang salah, pada status pembelian ini</>;
    }
  }
};

export default ModalSimpan;
